export const integrations = {
  statuses: {
    connected: 'Connected'
  },
  timepicker: 'Hours and minutes',
  menu: {
    title: 'Integrations',
    v1: 'List',
    settings: 'Settings'
  },
  breadcrumb: {
    title: 'Integrations',
    settings: {
      index: 'Settings CRM'
    },
    auth: {
      index: 'Authorization'
    },
    users: {
      index: 'Users CRM'
    },
    cases: {
      index: 'Integration scenarios'
    },
    numbers: {
      index: 'Numbers'
    }
  },
  tabs: {
    auth: 'Authorization',
    cases: 'Integration scenarios',
    users: 'Users',
    numbers: 'Number'
  },
  button: {
    sync_users: 'Synchronize users'
  },
  modal: {
    edit: 'Edit users'
  },
  users_status_default: 'Configurable. Calls are unavailable',
  users_status: {
    enabled: 'Calls are available',
    disabled: 'Turned off. Calls are unavailable'
  },
  page: {
    amo_info: 'Online CRM system. Customer management in modern cloud CRM — amoCRM.',
    kommo_info:
      'Kommo comes fully equipped with 8 key instruments that empower your people to sell more effectively.',
    connect: 'Connected:',
    tooltip: {
      other_integration: 'You already have another integration connected.'
    },
    button: {
      connect: 'Connect',
      loading: 'Loading...',
      settings: 'Settings',
      not_connected: 'The CRM widget is not connected'
    },
    no_integration: 'No integrations'
  },
  users_table: {
    tech_status: 'Technical status',
    amo_name: 'Name in CRM',
    amo_login: 'Login in CRM',
    amo_id: 'ID in CRM',
    sip_account: 'SIP account details',
    sip_password: 'SIP account password',
    caller_id: 'Caller ID',
    inner_number: 'Incoming number',
    queue_name: 'Is in the queue',
    queue: 'Queue'
  },
  settings: {
    request_info1: 'We have received your application to enable integration with CRM!',
    request_info2:
      'Technical specialists are already setting up incoming and outgoing lines for you. To fully use telephony, you need to select and connect a virtual number. We will contact you shortly for this.',
    account: {
      title: 'Account',
      description: '',
      settings: {
        main: {
          title: 'General',
          description: '',
          children: {
            domain: {
              title: 'Domain',
              description: 'Domain of the CRM copy that was connected to the current Zorra account'
            },
            amo_login: {
              title: 'Login',
              description:
                'Login of the CRM account that was connected to the current Zorra account'
            },
            status: {
              title: 'Status',
              description: ''
            },
            integration: {
              title: 'Integration'
            }
          }
        }
      }
    },
    integration_scenarios: {
      create_deal: 'Create a deal',
      create_task: 'Create a task',
      create_contact: 'Create a contact',
      create_note: 'Create a note',
      tooltip_contact: 'A contact will be created in CRM with the number of the calling client.',
      tooltip_deal2: "A transaction will be created in CRM with the caller's number.",
      create_deal_unsorted: 'Create a deal in "Unsorted"',
      tooltip_deal_unsorted:
        'In CRM, a deal with the number of the calling client will be created at the "Unparsed" stage.',
      tooltip_task:
        'If your employee did not answer the call, a task with a missed number will be created.',
      tooltip_time: 'Set the task completion time in hours and minutes. ',
      tooltip_deal: 'If a contact exists and he has no open deals, a new deal will be created.',
      tooltip_deal3: 'A transaction will be created in CRM with the dialed phone number.',
      tooltip_note:
        'For outgoing calls, if the subscriber did not answer, a note will be created: "Did not get through to +71234567890".',
      tooltip_outgoing_contact:
        'A contact with the number of the calling client will be created in CRM.',
      open_contact: 'Open contact',
      tooltip_open_contact:
        'With an incoming call from any number, a contact card will open in a new tab.',
      incoming: {
        title: 'Incoming calls',
        known: 'Known number',
        unknown: 'Unknown number',
        missed: 'Missed calls',
        deadline_task: 'Task deadline',
        any_call: 'Any call'
      },
      outgoing: {
        title: 'Outgoing calls',
        known: 'Known number',
        unknown: 'Unknown number',
        not_answered: 'Calls unanswered'
      }
    },
    users: {
      title: 'Users',
      description: '',
      settings: []
    },
    webhooks: {
      title: 'Webhooks',
      description: '',
      settings: []
    },
    additional: {
      title: 'Additional settings',
      description: '',
      settings: []
    }
  }
};
